module.exports = __webpack_public_path__ + "img/building-for-home.91150391.png";